"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var React = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var react_query_1 = require("react-query");
var button_component_1 = require("../../../common/buttons/button_component");
var drop_down_component_1 = require("../../../common/drop_down/drop_down_component");
var text_filed_with_fromto_Daterange_1 = require("../../../common/text_filed/text_filed_with_fromto_Daterange");
var tabs_component_1 = require("../../../common/tabs/tabs_component");
var Pagenotfound_1 = require("../../../ErrorBoundary/Pagenotfound");
var appConstants_1 = require("../../../constants/appConstants");
var route_path_1 = require("../../../constants/route_path");
var tabs_data_1 = require("../../../constants/tabs_data");
var menu_constants_1 = require("../../../menuList/menu_constants");
var routes_list_1 = require("../../../routes/routes_list");
var array_helpers_1 = require("../../../utils/array_helpers");
var reports_helper_1 = require("../reports/reports_helper");
var MyReportsHelpers_1 = require("./MyReportsHelpers");
var TODAY = new Date().toString();
var FORMAT = 'YYYY-MM-DD';
var MyReportsHomePage = function () {
    var location = (0, react_router_dom_1.useLocation)();
    var _a = (0, react_redux_1.useSelector)(function (state) { return state.appConfigList; }), reportTypeList = _a.reportTypeList, reportStatusList = _a.reportStatusList, weekly_report_types = _a.weekly_report_types;
    var features = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.My_Reports);
    var filteredTabs = (0, array_helpers_1.disableTabs)(tabs_data_1.TABS_DATA.MY_REPORTS_TABS_LIST, features);
    var myReportsRoutes = (0, array_helpers_1.getAccessibleRoutes)(menu_constants_1.FEATURE_CONSTANTS.My_Reports, routes_list_1.MYREPORTS_SUB_ROUES);
    var isSystemGenerated = location.pathname.includes(route_path_1.default.PATHS.SYSTEM_GENERATED);
    var _b = React.useState(null), selectedReportTypes = _b[0], setSelectedReportTypes = _b[1];
    var _c = React.useState(TODAY), filterFromDate = _c[0], setFromDateFilter = _c[1];
    var _d = React.useState(TODAY), filterToDate = _d[0], setToDateFilter = _d[1];
    var _e = React.useState(appConstants_1.defaultPageLimit), PageLimit = _e[0], setPageLimit = _e[1];
    var _f = React.useState(null), activeTab = _f[0], setActiveTab = _f[1];
    var _g = React.useState(1), pageCount = _g[0], setPageCount = _g[1];
    var _h = React.useState(false), isListReloaded = _h[0], setIsListReloaded = _h[1];
    var _j = React.useState(undefined), myReportList = _j[0], setMyReportList = _j[1];
    var _k = React.useState(''), errorMessage = _k[0], setErrorMessage = _k[1];
    var _l = React.useState(0), totalPageCount = _l[0], setTotalPageCount = _l[1];
    var _m = React.useState(0), totalCount = _m[0], setTotalCount = _m[1];
    var buildPayload = React.useCallback(function () {
        var size = PageLimit ? parseInt(PageLimit.value.toString(), 10) : 50;
        var payload = {
            system_download: isSystemGenerated,
            page: pageCount < 1 ? 1 : pageCount,
            size: size,
        };
        if (selectedReportTypes) {
            payload.report_type = selectedReportTypes.label;
        }
        if (filterFromDate && filterToDate) {
            payload.date_range = {
                start_date: moment(filterFromDate).format(FORMAT),
                end_date: moment(filterToDate).format(FORMAT),
            };
        }
        return payload;
    }, [isSystemGenerated, pageCount, PageLimit, selectedReportTypes, filterFromDate, filterToDate]);
    var refetch = (0, react_query_1.useQuery)(['myreports-list', pageCount, isSystemGenerated], function () {
        var payload = buildPayload();
        return (0, reports_helper_1.getMyreportList)(payload);
    }, {
        retry: false,
        onSuccess: function (response) {
            var size = PageLimit ? parseInt(PageLimit.value.toString(), 10) : 50;
            var convertedRes = (0, MyReportsHelpers_1.coonvertMyReportListFromRes)(response.result, reportStatusList);
            setMyReportList(convertedRes);
            setTotalPageCount(Math.ceil(response.count / size));
            setTotalCount(response.count);
            setErrorMessage('');
        },
        onError: function (err) {
            setErrorMessage(err);
            setMyReportList([]);
        },
    }).refetch;
    var reportTypeHandler = function (value) {
        setSelectedReportTypes(value);
    };
    var callBackOnDateRangeSelect = function (dateRangeArray) {
        if (dateRangeArray) {
            setFromDateFilter(moment(dateRangeArray.start).format(FORMAT));
            setToDateFilter(moment(dateRangeArray.end).format(FORMAT));
        }
        else {
            setFromDateFilter(null);
            setToDateFilter(null);
        }
    };
    var handlePageLimitChange = function (val) {
        setPageLimit(val);
    };
    var tabChangeHandler = function (val) {
        if (activeTab !== val) {
            setActiveTab(val);
            setFromDateFilter(TODAY);
            setToDateFilter(TODAY);
            setPageLimit(appConstants_1.defaultPageLimit);
            setSelectedReportTypes(null);
        }
    };
    var handlePageClick = function (data) {
        setPageCount(data.selected + 1);
    };
    var FilterHandler = function () {
        if (pageCount !== 1) {
            setPageCount(1);
        }
        else {
            refetch();
        }
    };
    var handleRefresh = function () {
        refetch();
    };
    var dropdownList = isSystemGenerated
        ? (weekly_report_types === null || weekly_report_types === void 0 ? void 0 : weekly_report_types.length) > 0 ? weekly_report_types : []
        : (reportTypeList === null || reportTypeList === void 0 ? void 0 : reportTypeList.length) > 0 ? reportTypeList : [];
    React.useEffect(function () {
        setPageCount(1);
    }, [isSystemGenerated]);
    return (React.createElement("div", null,
        React.createElement("div", { className: "tool-bar-wrapper" },
            React.createElement("div", { className: "page-heaidng" },
                React.createElement("h2", null, "My Reports"))),
        React.createElement("div", { className: "filter-menu-wrapper right-align-content" },
            React.createElement("div", { className: "filter-options" },
                React.createElement(drop_down_component_1.default, { label: isSystemGenerated ? 'Weekly Report Type' : 'Report Type', placeholder: isSystemGenerated ? 'Weekly Report Type' : 'Report Type', dropDownList: dropdownList, onChange: reportTypeHandler, value: selectedReportTypes, isDisabled: false, disableClearable: true }),
                React.createElement("div", { className: "cursor-pointer" },
                    React.createElement(text_filed_with_fromto_Daterange_1.default, { onChangeHandler: callBackOnDateRangeSelect, presentDate: true })),
                React.createElement(drop_down_component_1.default, { dropDownList: appConstants_1.paginationDropdown, onChange: handlePageLimitChange, value: PageLimit }),
                React.createElement(button_component_1.default, { buttonName: "FILTERS", color: "yellow-outline", onClickHandler: FilterHandler })),
            React.createElement(button_component_1.default, { buttonName: "Refresh", color: "yellow", endIcon: "icon-refresh", onClickHandler: handleRefresh })),
        React.createElement("div", { className: "scrollable-content" },
            React.createElement(tabs_component_1.default, { tabList: filteredTabs, tabChangeHandler: tabChangeHandler }),
            React.createElement(react_router_dom_1.Routes, null, myReportsRoutes === null || myReportsRoutes === void 0 ? void 0 :
                myReportsRoutes.map(function (route) { return (React.createElement(react_router_dom_1.Route, { index: true, path: route.path, key: route.path, element: React.createElement(appConstants_1.ReloadListContext.Provider, { value: { isListReloaded: isListReloaded, setIsListReloaded: setIsListReloaded } },
                        React.createElement(route.component, { PageLimit: PageLimit, myReportList: myReportList, errorMessage: errorMessage, pageCount: pageCount, totalPageCount: totalPageCount, totalCount: totalCount, handlePageClick: handlePageClick })) })); }),
                React.createElement(react_router_dom_1.Route, { path: "*", element: React.createElement(Pagenotfound_1.default, null) })))));
};
exports.default = MyReportsHomePage;
